import { ServiceLocator } from '../../app/ServiceLocator';
import { Formatters, Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { CommonErrorCode, FlowErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { FlowContentType } from '../../ts/models/ContentTypes';
import { FlowBaseInfo } from '../../ts/models/FlowInfo';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';

type FlowErrorInfo = {
  readonly flowName: string;
  readonly errorCode: number;
}

export namespace FlowErrors {
  export function errorDetailsFor(flowErrorItem: IErrorItem<FlowBaseInfo>): IErrorDetail {
    const flowErrorInfo: FlowErrorInfo = {
      flowName: flowErrorItem.item.name,
      errorCode: flowErrorItem.error.code
    };
    return {
      itemName: flowErrorItem.item.name,
      itemUrl:
        flowErrorItem.error.code === CommonErrorCode.FlowNotFound
          ? null
          : ContentUrlForItem(flowErrorItem.item, FlowContentType),
      errorMessage: this.errorMessageFor(flowErrorInfo)
    };
  }

  export function errorMessageFor(errorItem: FlowErrorInfo, noDefault?: boolean) {
    switch (errorItem.errorCode) {
      case CommonErrorCode.CallingUserInsufficientPermissions:
      case FlowErrorCode.FlowMoveInsufficientPermissionsOnDestinationProject:
        return Messages.errorFlowInsufficientPermissions();
      case CommonErrorCode.FlowNotFound:
        return Messages.errorFlowNotFound({ FLOW_NAME: L10n.elideIfLong(errorItem.flowName) });
      case FlowErrorCode.FlowWithSameNameInDestinationProject:
      case FlowErrorCode.FlowNameAlreadyExists:
        return Messages.errorFlowNameAlreadyExists();
      case FlowErrorCode.FlowDestinationProjectNotFound:
        return Messages.errorFlowDestinationProjectNotFound();
      case FlowErrorCode.FlowDescriptionTooLong:
        const serverService = getSessionManagementServiceInstance();
        return Messages.errorFlowDescriptionTooLong({ MAX_LENGTH: Formatters.formatCount(serverService.maxDescriptionLength()) });
      case CommonErrorCode.JobBulked:
        return Messages.errorFlowJobBulked();
      default:
        if (!noDefault) {
          return Messages.errorUnknown();
        }
    }
  }
}
